import { helpEmailByVariant } from "common/links";

import useAppVariant from "./useAppVariant";

export default function useHelpEmailByVariant() {
  const appVariant = useAppVariant();

  return helpEmailByVariant[appVariant];
}
